import { createFileRoute } from "@tanstack/react-router"
import { EditEventPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/$eventUuid/edit"
)({
  component: function EditEventRoute() {
    const { eventUuid } = Route.useParams()
    return (
      <AuthorizationGate resource={Resource.EVENT} action={Action.UPDATE}>
        <EditEventPage eventUuid={eventUuid} />
      </AuthorizationGate>
    )
  },
})
